
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/personalDetails',['Vue', 'vue!../reusableComponents/segment', 'vue!../reusableComponents/userForm'],function(Vue, segment, userForm){
        return {
            name:'PersonalDetails',
            template:template,
            components: {
                segment: segment,
                'user-form': userForm
            },
            data: function(){
                return {
                    showAllFields: false,
                    customerDetails: this.generateUserModel()
                }
            },
            methods: {
                loadMore: function(e) {
                    e.preventDefault();
                    this.showAllFields = !this.showAllFields;
                }
            },
            mounted: function() {
                var vm = this;

                var customerParams = {
                    params: {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    },
                    cb: function(res) {
                        vm.customerDetails = Object.assign(res.Customer[0], customerParams.params);
                    }
                }

                this.$store.dispatch('pmsCheckin/fetchCustomerDetails', customerParams);
            },
            watch: {
                customerDetails: {
                    deep: true,
                    handler: function(newVal, oldVal) {
                        this.$store.commit('pmsCheckin/updateCustomerDetails', newVal);
                    }
                }
            }
        }
    })
})('<segment> <template v-slot:header> <i class="fas fa-user"></i> {{localization.roomReservation.pmsCheckIn.personalDetailsHeader}} </template> <template v-slot:body> <user-form :showAllFields="showAllFields" @loadMore="loadMore" loadMoreText="Load more" :initialData="customerDetails" /> </template> </segment>');
